import { useMutation, useQuery } from 'react-query';
import { JobPositionService } from '@api/JobPositionService';
import { onDefaultError } from '../helpers/commonHelpers';

// Records
const useListJobPosition = (
  [page_no, searchText, selectedStatus],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['job-position-list', page_no, searchText, selectedStatus],
    JobPositionService.listJobPosition,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

// Create
const useAddJobPosition = (onSuccess, onError = onDefaultError) => {
  return useMutation(JobPositionService.addJobPosition, {
    onSuccess,
    onError
  });
};
// Details
const useViewJobPosition = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('job-position-view', () => JobPositionService.viewJobPosition(id), {
    onSuccess,
    onError
  });
};

// Details
const useShowJobPosition = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('job-position-show', () => JobPositionService.showJobPosition(id), {
    onSuccess,
    onError
  });
};

const useUpdateJobPosition = (onSuccess, onError = onDefaultError) => {
  return useMutation(JobPositionService.updateJobPosition, {
    onSuccess,
    onError
  });
};

// Delete
const useDeleteJobPosition = (onSuccess, onError = onDefaultError) => {
  return useMutation(JobPositionService.deleteJobPosition, {
    onSuccess,
    onError
  });
};

const useUpdateJobPositionStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(JobPositionService.changeStatusJobPosition, {
    onSuccess,
    onError
  });
};

export {
  useListJobPosition,
  useAddJobPosition,
  useViewJobPosition,
  useUpdateJobPosition,
  useDeleteJobPosition,
  useUpdateJobPositionStatus,
  useShowJobPosition
};
